// extracted by mini-css-extract-plugin
export default {"mobileNav":"navbar_mobileNav__FJsKi"};